// Generated by scripts/build-metro-hubs.js from refreshed casino and tournament seed. Do not hand-edit.
module.exports = {
  "houston-poker-rooms": {
    "title": "Houston Poker Tournaments Today & Near You | Daily Tourneys",
    "h1": "Houston poker tournaments, poker rooms, and card rooms",
    "description": "Houston poker tournaments today and this week at card rooms near you in Houston, Katy, Cypress, Spring, Humble, Baytown, and Webster: times and buy-ins.",
    "intro": "Houston poker tournaments run at private poker clubs and card rooms, not casinos: Texas Card House, Champions Club, Doghouse Poker Club, The Hangar, 101 Poker Club, Spades Poker House, and more in Houston, Katy, Cypress, Spring, Humble, Baytown, and Webster. Most Houston poker rooms charge a membership or entry fee on top of the tournament buy-in, so check with the club before you go. Open a room for contact details and its daily and weekly tournaments. Daily and weekly events are listed under a room only when a schedule is on file. 8 of the 9 rooms here have a tournament schedule on file, with buy-ins from $20 to $150, and events on every day of the week.",
    "footerLabel": "Houston poker rooms",
    "shortLabel": "Houston",
    "rooms": [
      {
        "name": "Spades Poker House Baytown",
        "city": "Baytown",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$3K GTD Freeroll",
            "start": "6:30pm",
            "buyin": "$0"
          },
          {
            "day": "Thursdays",
            "name": "$3K GTD Freeroll",
            "start": "6:30pm",
            "buyin": "$0"
          }
        ]
      },
      {
        "name": "Doghouse Poker Club",
        "city": "Cypress",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$2.5K GTD Freeze Out",
            "start": "7:00pm",
            "buyin": "$75"
          },
          {
            "day": "Tuesdays",
            "name": "$2.5K GTD R.O.E. Rebuy Frenzy",
            "start": "7:00pm",
            "buyin": "$40"
          },
          {
            "day": "Wednesdays",
            "name": "$2.5K GTD Freeze Out",
            "start": "7:00pm",
            "buyin": "$75"
          },
          {
            "day": "Thursdays",
            "name": "$3K GTD Freeroll",
            "start": "7:00pm",
            "buyin": "$0"
          },
          {
            "day": "Fridays",
            "name": "$3K GTD Thaw & Chill",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "$5K GTD Re-Entry",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Sundays",
            "name": "$3K GTD Freeroll",
            "start": "2:00pm",
            "buyin": "$0"
          }
        ]
      },
      {
        "name": "Champions Club Texas",
        "city": "Houston",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "1K GTD 40/40/40 Daily NLH",
            "start": "1:00pm",
            "buyin": "$40"
          },
          {
            "day": "Mondays",
            "name": "4K Monday Night 40/40/40 NLH",
            "start": "5:30pm",
            "buyin": "$40"
          },
          {
            "day": "Wednesdays",
            "name": "5K Midweek PLO",
            "start": "5:30pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "2K GTD Turbo NLH w/ Friday Entry",
            "start": "5:30pm",
            "buyin": "$20"
          },
          {
            "day": "Fridays",
            "name": "15K GTD Friday Unchained NLH",
            "start": "5:30pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Texas Card House Houston",
        "city": "Houston",
        "state": "TX",
        "schedules": [
          {
            "day": "Fridays",
            "name": "Friday Mayhem Special",
            "start": "6:00pm",
            "buyin": "$25"
          },
          {
            "day": "Thursdays",
            "name": "$140 NLH",
            "start": "6:00pm",
            "buyin": "$140"
          },
          {
            "day": "Mondays",
            "name": "$25 NLH",
            "start": "6:00pm",
            "buyin": "$25"
          },
          {
            "day": "Saturdays",
            "name": "PLO Blitz",
            "start": "2:00pm",
            "buyin": "$25"
          },
          {
            "day": "Saturdays",
            "name": "$80 NLH",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Tuesdays",
            "name": "$80 NLH",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Wednesdays",
            "name": "$25 NLH",
            "start": "6:00pm",
            "buyin": "$25"
          },
          {
            "day": "Sundays",
            "name": "$140 NLH",
            "start": "2:00pm",
            "buyin": "$140"
          }
        ]
      },
      {
        "name": "The Hangar Poker House",
        "city": "Humble",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$5K GTD NLH",
            "start": "5:15pm",
            "buyin": "$50"
          },
          {
            "day": "Tuesdays",
            "name": "$1K GTD NLH Freeroll",
            "start": "5:15pm",
            "buyin": "$0"
          },
          {
            "day": "Wednesdays",
            "name": "$1.5K GTD NLH Freeroll",
            "start": "5:15pm",
            "buyin": "$0"
          },
          {
            "day": "Thursdays",
            "name": "$1.5K GTD ROE Freeroll",
            "start": "5:15pm",
            "buyin": "$0"
          },
          {
            "day": "Fridays",
            "name": "$2.5K GTD NLH Freeroll",
            "start": "5:15pm",
            "buyin": "$0"
          },
          {
            "day": "Saturdays",
            "name": "$5K GTD NLH",
            "start": "5:15pm",
            "buyin": "$50"
          },
          {
            "day": "Sundays",
            "name": "$2K GTD NLH",
            "start": "5:15pm",
            "buyin": "$20"
          }
        ]
      },
      {
        "name": "101 Poker Club",
        "city": "Katy",
        "state": "TX",
        "schedules": [
          {
            "day": "Tuesdays, Thursdays",
            "name": "$60 ROE",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "$100 Freezeout",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "PLO Bomb Pots",
            "start": "1:05pm",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "$100 Freezeout",
            "start": "7:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Texas Card House Spring",
        "city": "Spring",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Mega Monday",
            "start": "6:00pm",
            "buyin": "$140"
          },
          {
            "day": "Fridays",
            "name": "Friday Turbo",
            "start": "2:00pm",
            "buyin": "$25"
          },
          {
            "day": "Fridays",
            "name": "Spring Standard",
            "start": "5:00pm",
            "buyin": "$140"
          },
          {
            "day": "Mondays",
            "name": "Monday Turbo",
            "start": "2:00pm",
            "buyin": "$25"
          },
          {
            "day": "Saturdays",
            "name": "$40 to Fortune",
            "start": "2:00pm",
            "buyin": "$40"
          },
          {
            "day": "Sundays",
            "name": "Sunday Funday",
            "start": "2:00pm",
            "buyin": "$25"
          },
          {
            "day": "Thursdays",
            "name": "Super Thursday",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Tuesdays",
            "name": "Super Tuesday",
            "start": "6:00pm",
            "buyin": "$40"
          }
        ]
      },
      {
        "name": "Spades Poker House Webster",
        "city": "Webster",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays",
            "name": "PLO Rebuy",
            "start": "6:30pm",
            "buyin": "$20"
          },
          {
            "day": "Wednesdays",
            "name": "NLH Rebuy",
            "start": "6:00pm",
            "buyin": "$20"
          },
          {
            "day": "Thursdays",
            "name": "PLO Rebuy",
            "start": "6:30pm",
            "buyin": "$20"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "6:30pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "Weekend Mixed Format",
            "start": "2:00pm",
            "buyin": "$20"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLH",
            "start": "2:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Empire Poker Club",
        "city": "Houston",
        "state": "TX",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/texas-poker-rooms",
      "label": "All Texas poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Lonestar Social Poker Club",
        "city": "Houston",
        "state": "TX"
      },
      {
        "name": "Paramount Social Club",
        "city": "Houston",
        "state": "TX"
      },
      {
        "name": "Prime Social Club",
        "city": "Houston",
        "state": "TX"
      }
    ]
  },
  "dallas-poker-rooms": {
    "title": "Dallas–Fort Worth Poker Rooms & Schedules | Daily Tourneys",
    "h1": "Dallas–Fort Worth poker rooms and tournament schedules",
    "description": "Poker rooms in Dallas, Irving, Grand Prairie, Burleson, and Aledo, with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in Dallas, Irving, Grand Prairie, Burleson, and Aledo. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Dallas–Fort Worth poker rooms",
    "shortLabel": "Dallas–Fort Worth",
    "rooms": [
      {
        "name": "The Fort Card Room",
        "city": "Aledo",
        "state": "TX",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "$100 NL Holdem",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "$100 NL Holdem",
            "start": "2:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays",
            "name": "$100 FL Omaha",
            "start": "7:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Poker House Fort Worth",
        "city": "Burleson",
        "state": "TX",
        "schedules": [
          {
            "day": "Daily",
            "name": "Noon Freeroll NL Holdem",
            "start": "12:00pm",
            "buyin": "Free"
          },
          {
            "day": "Thursdays",
            "name": "$65 NL Holdem",
            "start": "6:30pm",
            "buyin": "$65"
          }
        ]
      },
      {
        "name": "Champions Social Club",
        "city": "Dallas",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "$70 NL Holdem",
            "start": "10:30am",
            "buyin": "$70"
          }
        ]
      },
      {
        "name": "Shuffle 214",
        "city": "Dallas",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Weekday Freeroll $1,200 GTD",
            "start": "2:00pm",
            "buyin": "$0"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Freeroll $2,000 GTD w/ PLO Bomb Pots",
            "start": "6:00pm",
            "buyin": "$0"
          },
          {
            "day": "Wednesdays",
            "name": "NEW PLO Freeroll",
            "start": "6:00pm",
            "buyin": "$0"
          },
          {
            "day": "Thursdays",
            "name": "$3,000 GTD Freeroll After Dark",
            "start": "6:00pm",
            "buyin": "$0"
          },
          {
            "day": "Fridays",
            "name": "$5,000 GTD Friday Double Board PLO $50 Entry",
            "start": "6:00pm",
            "buyin": "$50"
          },
          {
            "day": "Sundays",
            "name": "$150 Sunday Showdown $10,000 GTD",
            "start": "6:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "Texas Card House Dallas",
        "city": "Dallas",
        "state": "TX",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "Green Chip Bounty",
            "start": "11:00am",
            "buyin": "$125"
          },
          {
            "day": "Wednesdays",
            "name": "PLO Bomb Pots",
            "start": "6:00pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Palace Poker Texas",
        "city": "Grand Prairie",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Breakfast Club Morning Turbo",
            "start": "10:00am",
            "buyin": "$45"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Daily NLH $2K GTD",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "Monday Green Chip Bounty $5K GTD",
            "start": "6:00pm",
            "buyin": "$125"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Nightly $3K GTD",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Thursdays",
            "name": "PLO Deep Stack $3K GTD",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Fridays",
            "name": "Friday Night Re-Entry $10K GTD",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "Palace Powerstack $30K GTD",
            "start": "11:00am",
            "buyin": "$150"
          },
          {
            "day": "Sundays",
            "name": "Sunday Saddle-Up $20K GTD",
            "start": "11:00am",
            "buyin": "$120"
          }
        ]
      },
      {
        "name": "TCH Social Las Colinas",
        "city": "Irving",
        "state": "TX",
        "schedules": [
          {
            "day": "Sundays, Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
            "name": "Morning Mayhem",
            "start": "9:00am",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "Sunday DoubleStack",
            "start": "2:00pm",
            "buyin": "$150"
          }
        ]
      }
    ],
    "parent": {
      "to": "/texas-poker-rooms",
      "label": "All Texas poker rooms"
    }
  },
  "austin-poker-rooms": {
    "title": "Austin Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Austin poker rooms and tournament schedules",
    "description": "Poker rooms in Austin and Round Rock, with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in Austin and Round Rock. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Austin poker rooms",
    "shortLabel": "Austin",
    "rooms": [
      {
        "name": "Shuffle 512",
        "city": "Austin",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Wednesdays",
            "name": "$2,000 GTD Round X Round Freeroll",
            "start": "7:00pm",
            "buyin": "$0"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$2,000 GTD NLH Freeroll",
            "start": "7:00pm",
            "buyin": "$0"
          },
          {
            "day": "Fridays",
            "name": "$3,000 GTD Freeroll Tournament",
            "start": "7:00pm",
            "buyin": "$0"
          },
          {
            "day": "Saturdays",
            "name": "$2,000 NLH Freeroll Tournament",
            "start": "7:00pm",
            "buyin": "$0"
          },
          {
            "day": "Sundays",
            "name": "$1,500 GTD Freeroll",
            "start": "7:00pm",
            "buyin": "$0"
          }
        ]
      },
      {
        "name": "TCH Social Austin",
        "city": "Austin",
        "state": "TX",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
            "name": "Daily Bankroll Builder",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "Almost Freezeout",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Fridays, Sundays",
            "name": "Daily Bankroll Builder XXL",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "Re-buy Roundup",
            "start": "6:00pm",
            "buyin": "$30"
          },
          {
            "day": "Sundays",
            "name": "PKO Bounty",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays",
            "name": "Pot Limit Big O",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Triple Stack",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Fridays",
            "name": "TGIF",
            "start": "6:00pm",
            "buyin": "$140"
          },
          {
            "day": "Saturdays",
            "name": "Mega Stack",
            "start": "6:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "The Lodge Card Club Round Rock",
        "city": "Round Rock",
        "state": "TX",
        "schedules": [
          {
            "day": "Tuesdays",
            "name": "Texas Freeroll",
            "start": "6:15pm",
            "buyin": "$30"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Freeroll",
            "start": "6:15pm",
            "buyin": "$30"
          },
          {
            "day": "Fridays",
            "name": "Friday Freeroll",
            "start": "6:15pm",
            "buyin": "$120"
          },
          {
            "day": "Sundays",
            "name": "Sunday Deep Stack",
            "start": "12:15pm"
          },
          {
            "day": "3rd Saturday of the month",
            "name": "The Art of Poker",
            "start": "12:15pm",
            "buyin": "$250"
          },
          {
            "day": "2nd Saturday of the month",
            "name": "The Big One Re-Entry",
            "start": "12:15pm",
            "buyin": "$360"
          }
        ]
      }
    ],
    "parent": {
      "to": "/texas-poker-rooms",
      "label": "All Texas poker rooms"
    }
  },
  "las-vegas-poker-rooms": {
    "title": "Las Vegas Poker Tournaments Today | Daily Tourneys",
    "h1": "Las Vegas poker tournaments today and casino poker rooms",
    "description": "Las Vegas poker tournaments today and this week: daily casino tournament start times and buy-ins at Las Vegas and Henderson poker rooms, room by room.",
    "intro": "Poker rooms in Las Vegas and Henderson. Open a room for phone, hours, and games. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Las Vegas poker rooms",
    "shortLabel": "Las Vegas",
    "rooms": [
      {
        "name": "Green Valley Ranch Resort, Casino & Spa",
        "city": "Henderson",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "$99 NL Hold'em",
            "start": "12:00pm",
            "buyin": "$99"
          }
        ]
      },
      {
        "name": "Aria Resort & Casino, Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily No Limit Hold'em",
            "start": "1:00pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Bellagio Hotel & Casino",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "$150 NLH $2K GTD",
            "start": "12:00pm",
            "buyin": "$150"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "$150 NLH $2K GTD",
            "start": "5:00pm",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "$200 NLH $3K GTD",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Saturdays",
            "name": "$200 NLH $50 Bounty $3K GTD",
            "start": "5:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "$200 NLH $50 Bounty $3K GTD",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "$200 NLH $3K GTD",
            "start": "5:00pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Caesars Palace, Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "10:00am",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "2:00pm",
            "buyin": "$160"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "9:00pm",
            "buyin": "$160"
          }
        ]
      },
      {
        "name": "Horseshoe Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "9:00am",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "11:00am",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "2:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "5:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "8:00pm",
            "buyin": "$160"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "11:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Mandalay Bay, Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays, Wednesdays, Thursdays, Fridays, Sundays",
            "name": "Daily NLH",
            "start": "8:00pm",
            "buyin": "$60"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Night NLH",
            "start": "8:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "MGM Grand, Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Sundays",
            "name": "Daily NLH",
            "start": "11:10am",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "Saturday NLH",
            "start": "11:10am",
            "buyin": "$150"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "7:10pm",
            "buyin": "$120"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "11:10pm",
            "buyin": "$120"
          }
        ]
      },
      {
        "name": "Red Rock Casino Resort & Spa",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
            "name": "Daily No-Limit Hold'em",
            "start": "11:05am",
            "buyin": "$85"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
            "name": "Daily No-Limit Hold'em",
            "start": "6:05pm",
            "buyin": "$85"
          },
          {
            "day": "Sundays",
            "name": "Sunday Funday Bounty NLH",
            "start": "11:05am",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "South Point Hotel, Casino & Spa",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
            "name": "Daily NLH",
            "start": "10:10am",
            "buyin": "$120"
          },
          {
            "day": "Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "10:10am",
            "buyin": "$120"
          },
          {
            "day": "Mondays, Thursdays, Saturdays, Sundays",
            "name": "Chip Chop Survivor",
            "start": "2:10pm",
            "buyin": "$120"
          },
          {
            "day": "Tuesdays",
            "name": "Omaha 8/B",
            "start": "2:10pm",
            "buyin": "$120"
          },
          {
            "day": "Wednesdays, Fridays",
            "name": "Crazy Pineapple Turbo",
            "start": "2:10pm",
            "buyin": "$120"
          },
          {
            "day": "Mondays, Tuesdays, Thursdays",
            "name": "Nightly NLH",
            "start": "6:10pm",
            "buyin": "$120"
          },
          {
            "day": "Wednesdays, Saturdays",
            "name": "NLH Deep Stack",
            "start": "6:10pm",
            "buyin": "$200"
          },
          {
            "day": "Fridays, Sundays",
            "name": "NLH Bounty",
            "start": "6:10pm",
            "buyin": "$200"
          },
          {
            "day": "Mondays, Thursdays",
            "name": "Crazy Pineapple Turbo",
            "start": "10:10pm",
            "buyin": "$120"
          },
          {
            "day": "Tuesdays, Fridays, Saturdays",
            "name": "NLH Turbo Bounty",
            "start": "10:10pm",
            "buyin": "$120"
          },
          {
            "day": "Wednesdays, Sundays",
            "name": "Chip Chop Survivor",
            "start": "10:10pm",
            "buyin": "$120"
          }
        ]
      },
      {
        "name": "The Orleans Hotel & Casino",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Sundays",
            "name": "50k Sunday Special Super Stack",
            "start": "11:05am",
            "buyin": "$200"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Super Stack NLH",
            "start": "11:05am",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "Monster Stack NLH",
            "start": "11:05am",
            "buyin": "$150"
          },
          {
            "day": "Mondays",
            "name": "H.O.R.S.E.",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays",
            "name": "T.O.R.S.E.",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Wednesdays",
            "name": "O.E. (Omaha-8 / Stud-8)",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Thursdays",
            "name": "T.O.E.",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Fridays",
            "name": "Omaha-8",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "Triple-Triple Draw",
            "start": "4:05pm",
            "buyin": "$150"
          },
          {
            "day": "Sundays",
            "name": "Big-O",
            "start": "6:05pm",
            "buyin": "$150"
          },
          {
            "day": "Mondays, Tuesdays, Thursdays",
            "name": "Monster Stack NLH",
            "start": "6:05pm",
            "buyin": "$150"
          },
          {
            "day": "Wednesdays",
            "name": "Super Stack NLH",
            "start": "6:05pm",
            "buyin": "$120"
          },
          {
            "day": "Fridays",
            "name": "20K Friday Night Monster Stack",
            "start": "6:05pm",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "NLH Bounty",
            "start": "6:05pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "The Venetian",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "$200 NLH Bounty $10K GTD",
            "start": "5:10pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Westgate Las Vegas Resort & Casino",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "12:05pm",
            "buyin": "$55"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily Crazy Pineapple",
            "start": "3:05pm",
            "buyin": "$70"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "5:05pm",
            "buyin": "$70"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "7:05pm",
            "buyin": "$55"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Daily NLH",
            "start": "9:05pm",
            "buyin": "$70"
          }
        ]
      },
      {
        "name": "Wynn, Las Vegas",
        "city": "Las Vegas",
        "state": "NV",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
            "name": "Daily NLH $10K GTD",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Fridays",
            "name": "Friday NLH Rebuy $40K GTD",
            "start": "12:00pm",
            "buyin": "$240"
          },
          {
            "day": "Saturdays",
            "name": "Saturday NLH $25K GTD",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLH $25K GTD",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "Nightly NLH $10K GTD",
            "start": "6:00pm",
            "buyin": "$160"
          }
        ]
      }
    ]
  },
  "los-angeles-poker-rooms": {
    "title": "Los Angeles Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Los Angeles poker rooms and tournament schedules",
    "description": "Los Angeles area card rooms in Bell Gardens, Commerce, Compton, Gardena, Hawaiian Gardens, and Inglewood, with schedules on file.",
    "intro": "Card rooms in Bell Gardens, Commerce, Compton, Gardena, Hawaiian Gardens, and Inglewood. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Los Angeles poker rooms",
    "shortLabel": "Los Angeles",
    "rooms": [
      {
        "name": "The Bicycle Hotel & Casino",
        "city": "Bell Gardens",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Nooner",
            "start": "12:00pm",
            "buyin": "$40+$10"
          },
          {
            "day": "Fridays",
            "name": "Quantum Reload Session A",
            "start": "12:00pm",
            "buyin": "$27+$13"
          },
          {
            "day": "Fridays",
            "name": "Quantum Reload Session B",
            "start": "2:10pm",
            "buyin": "$37+$13"
          },
          {
            "day": "Saturdays",
            "name": "Quantum Reload Session A",
            "start": "12:00pm",
            "buyin": "$37+$13"
          },
          {
            "day": "Saturdays",
            "name": "Quantum Reload Session B",
            "start": "2:00pm",
            "buyin": "$50+$15"
          },
          {
            "day": "Saturdays",
            "name": "Quantum Reload Session C",
            "start": "4:00pm",
            "buyin": "$60+$20"
          },
          {
            "day": "Sundays",
            "name": "Quantum Reload Session A",
            "start": "12:00pm",
            "buyin": "$37+$13"
          },
          {
            "day": "Sundays",
            "name": "Quantum Reload Session B",
            "start": "2:00pm",
            "buyin": "$50+$15"
          },
          {
            "day": "Sundays",
            "name": "Quantum Reload Session C",
            "start": "4:00pm",
            "buyin": "$60+$20"
          },
          {
            "day": "Thursdays, Fridays, Saturdays",
            "name": "Late Nite Madness Bounty",
            "start": "10:00pm",
            "buyin": "$50+$10"
          }
        ]
      },
      {
        "name": "Commerce Casino",
        "city": "Commerce",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Daily NLHE $2,000 GTD",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
            "name": "Daily NLHE $5,000 GTD",
            "start": "4:00pm",
            "buyin": "$140"
          },
          {
            "day": "Fridays",
            "name": "Friday NLHE $5,000 GTD",
            "start": "4:00pm",
            "buyin": "$140"
          },
          {
            "day": "Saturdays",
            "name": "Saturday NLHE $25,000 GTD",
            "start": "12:00pm",
            "buyin": "$250"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLHE $15,000 GTD",
            "start": "12:00pm",
            "buyin": "$250"
          }
        ]
      },
      {
        "name": "Larry Flynt's Lucky Lady Casino",
        "city": "Gardena",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "NLH Unlimited Rebuy",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "No-Limit Hold'em",
            "start": "7:00pm",
            "buyin": "$80"
          },
          {
            "day": "Tuesdays",
            "name": "Big O",
            "start": "1:00pm",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays",
            "name": "No-Limit Hold'em",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "NLH Unlimited Rebuy",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "No-Limit Hold'em",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "NLH Unlimited Rebuy",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "No-Limit Hold'em",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "No-Limit Hold'em",
            "start": "1:00pm",
            "buyin": "$80"
          },
          {
            "day": "Fridays",
            "name": "Friday Night Grind",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Showdown",
            "start": "3:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "Royal Sunday",
            "start": "3:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "The Gardens Casino",
        "city": "Hawaiian Gardens",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Daily NLH $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Afternoon NLH $5K GTD",
            "start": "12:15pm",
            "buyin": "$75 ($65+$10)"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Night NLH Bounty $5K GTD",
            "start": "6:45pm",
            "buyin": "$75 ($65+$10)"
          },
          {
            "day": "Wednesdays",
            "name": "Daily NLH Bounty $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          },
          {
            "day": "Thursdays",
            "name": "Daily NLH $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          },
          {
            "day": "Fridays",
            "name": "Daily NLH Bounty $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          },
          {
            "day": "Fridays",
            "name": "Friday Deep Stack NLH $20K GTD",
            "start": "5:00pm",
            "buyin": "$300 ($250+$30+$20)"
          },
          {
            "day": "Saturdays",
            "name": "Saturday NLH $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLH Bounty $10K GTD",
            "start": "11:00am",
            "buyin": "$130 ($100+$18+$12)"
          }
        ]
      },
      {
        "name": "Hollywood Park Casino",
        "city": "Inglewood",
        "state": "CA",
        "schedules": [
          {
            "day": "Tuesdays",
            "name": "$12K Tuesdays",
            "start": "3:00pm",
            "buyin": "$160+$100"
          },
          {
            "day": "Wednesdays",
            "name": "Big O",
            "start": "11:00am",
            "buyin": "$125"
          },
          {
            "day": "Wednesdays",
            "name": "$10K NLHE + $50 Bounty",
            "start": "6:00pm",
            "buyin": "$250"
          },
          {
            "day": "Thursdays",
            "name": "$12K Thursdays",
            "start": "3:00pm",
            "buyin": "$160+$100"
          },
          {
            "day": "Fridays",
            "name": "TGIF + Bounty",
            "start": "10:00am",
            "buyin": "$200–$300"
          },
          {
            "day": "Saturdays",
            "name": "$8K Bankroll Builder",
            "start": "10:00am",
            "buyin": "$100+$100"
          }
        ]
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Crystal Casino",
        "city": "Compton",
        "state": "CA"
      },
      {
        "name": "Hustler Casino",
        "city": "Gardena",
        "state": "CA"
      }
    ]
  },
  "san-diego-poker-rooms": {
    "title": "San Diego Poker Rooms & Tournaments Today | Daily Tourneys",
    "h1": "San Diego poker rooms and poker tournaments",
    "description": "Poker in San Diego at Sycuan, Jamul, Seven Mile and Ocean’s 11: 24-hour poker rooms and no-limit hold’em tournaments tonight and this week.",
    "intro": "Looking for poker in San Diego? The San Diego area poker rooms on file are Sycuan Casino in El Cajon, about 20 miles east of downtown, Jamul Casino Resort in Jamul, Seven Mile Casino in Chula Vista, and Ocean’s 11 Casino, a card room in Oceanside in North County. Sycuan, Jamul, and Ocean’s 11 run daily no-limit hold’em tournaments; Seven Mile spreads poker but publishes no tournament schedule. Sycuan, Seven Mile, and Ocean’s 11 are open 24 hours. Each room page lists the days, start times, and buy-ins we have. Daily and weekly events are listed under a room only when a schedule is on file. 3 of the 4 rooms here have a tournament schedule on file, with buy-ins from $20 to $200, and events on every day of the week.",
    "footerLabel": "San Diego area poker rooms",
    "shortLabel": "San Diego area",
    "rooms": [
      {
        "name": "Sycuan Casino",
        "city": "El Cajon",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Wednesdays, Fridays",
            "name": "NLH",
            "start": "12:00pm",
            "buyin": "$55"
          },
          {
            "day": "Tuesdays, Thursdays, Sundays",
            "name": "NLH Deep Stack Rebuy",
            "start": "12:00pm",
            "buyin": "$20"
          },
          {
            "day": "Sundays",
            "name": "Rebuy/Add-on NLH",
            "start": "4:00pm",
            "buyin": "$50"
          },
          {
            "day": "Saturdays",
            "name": "NLH",
            "start": "4:00pm",
            "buyin": "$80"
          },
          {
            "day": "Wednesdays",
            "name": "Rebuy/Add-on NLH",
            "start": "6:00pm",
            "buyin": "$50"
          },
          {
            "day": "Mondays, Thursdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$75"
          },
          {
            "day": "Tuesdays",
            "name": "Bounty",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "Two Chip Bounty NLH",
            "start": "6:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "Jamul Casino Resort",
        "city": "Jamul",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$60"
          },
          {
            "day": "Mondays, Wednesdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Saturdays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$40"
          },
          {
            "day": "Saturdays (1st, 3rd, 4th and 5th each month)",
            "name": "NLH",
            "start": "4:00pm",
            "buyin": "$60"
          },
          {
            "day": "Saturdays (2nd and 4th each month)",
            "name": "Helix Poker Series NLHE",
            "start": "4:00pm",
            "buyin": "$125"
          },
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$80"
          },
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "4:00pm",
            "buyin": "$40"
          }
        ]
      },
      {
        "name": "Ocean's 11 Casino",
        "city": "Oceanside",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Wednesdays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$130 ($100+$25)"
          },
          {
            "day": "Mondays, Wednesdays",
            "name": "NLH Bounty",
            "start": "6:00pm",
            "buyin": "$155 ($100+$25+$25 bounty)"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "NLH Bounty",
            "start": "10:00am",
            "buyin": "$155 ($100+$25+$25 bounty)"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$130 ($100+$25)"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$125 ($100+$25)"
          },
          {
            "day": "Saturdays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$200 ($160+$30)"
          },
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "10:00am",
            "buyin": "$150 ($110+$30)"
          },
          {
            "day": "Sundays",
            "name": "NLH Bounty",
            "start": "6:00pm",
            "buyin": "$155 ($100+$25+$25 bounty)"
          }
        ]
      },
      {
        "name": "Seven Mile Casino",
        "city": "Chula Vista",
        "state": "CA",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Barona Resort & Casino",
        "city": "Lakeside",
        "state": "CA"
      }
    ]
  },
  "miami-poker-rooms": {
    "title": "Poker Tournaments Near Miami & South Florida | Daily Tourneys",
    "h1": "Poker tournaments near Miami and South Florida",
    "description": "Daily poker tournaments near Miami at Seminole Hard Rock Hollywood, Seminole Coconut Creek, The Casino @ Dania Beach, The Big Easy, and Harrah’s Pompano Beach.",
    "intro": "Looking for poker tournaments near Miami? The South Florida poker rooms on file are in Hollywood, Hallandale Beach, Dania Beach, Pompano Beach, and Coconut Creek, all within about 40 miles of downtown Miami: Seminole Hard Rock Hollywood, Seminole Casino Coconut Creek, The Casino @ Dania Beach, The Big Easy Casino, and Harrah’s Pompano Beach. Open a room for contact details and its daily and weekly tournaments. Daily and weekly events are listed under a room only when a schedule is on file. All 5 rooms here have a tournament schedule on file, with buy-ins from $20 to $250, and events on every day of the week.",
    "footerLabel": "Miami & South Florida poker rooms",
    "shortLabel": "Miami & South Florida",
    "rooms": [
      {
        "name": "Seminole Casino, Coconut Creek",
        "city": "Coconut Creek",
        "state": "FL",
        "schedules": [
          {
            "day": "Sundays",
            "name": "Sunday Morning Turbo Bounty NLH $5K GTD",
            "start": "10:00am",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "Sunday Evening Crazy Pineapple $2.5K GTD",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays",
            "name": "Monday Morning Survivor NLH $2.4K GTD",
            "start": "11:00am",
            "buyin": "$80"
          },
          {
            "day": "Mondays",
            "name": "Monday Evening Double Green Chip Bounty $10K GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Morning Omaha Hi-Lo $2K GTD",
            "start": "11:00am",
            "buyin": "$130"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Evening Turbo Bounty NLH $2.5K GTD",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Morning Re-Do NLH Turbo $2K GTD",
            "start": "11:00am",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Evening Deep Stack NLH $10K GTD",
            "start": "6:00pm",
            "buyin": "$130"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Morning Turbo Bounty NLH $2K GTD",
            "start": "11:00am",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Evening Bombpot Turbo NLH",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Fridays",
            "name": "Friday Morning Crazy Pineapple Survivor $2.4K GTD",
            "start": "11:00am",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "Friday Evening Double Green Chip Bounty $10K GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Morning Triple Stack NLH $5K GTD",
            "start": "10:00am",
            "buyin": "$140"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Evening Deep Stack NLH $2.5K GTD",
            "start": "6:00pm",
            "buyin": "$130"
          }
        ]
      },
      {
        "name": "The Casino @ Dania Beach",
        "city": "Dania Beach",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Monday Deepstack $120 / $5K GTD",
            "start": "6:00pm",
            "buyin": "$120"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday $100 / $5K GTD",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday $60 / $4K GTD",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Deepstack $120 / $5K GTD",
            "start": "6:00pm",
            "buyin": "$120"
          },
          {
            "day": "Fridays",
            "name": "Friday $200 / $15K GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Saturdays",
            "name": "Saturday $20 / $4K GTD Rebuy",
            "start": "4:00pm",
            "buyin": "$20"
          }
        ]
      },
      {
        "name": "The Big Easy Casino",
        "city": "Hallandale Beach",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays, Wednesdays",
            "name": "$30 NLH",
            "start": "7:00pm",
            "buyin": "$30"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$50 NLH",
            "start": "7:00pm",
            "buyin": "$50"
          }
        ]
      },
      {
        "name": "Seminole Hard Rock Hotel & Casino, Hollywood",
        "city": "Hollywood",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Deep Stack NLHE $30,000 GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Tuesdays",
            "name": "Deep Stack Double Green Chip Bounty $5,000 GTD",
            "start": "11:00am",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays",
            "name": "Quad Stack NLHE $20,000 GTD",
            "start": "6:00pm",
            "buyin": "$250"
          },
          {
            "day": "Wednesdays",
            "name": "Quad Stack Double Green Chip Bounty (Freeze-Out)",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Thursdays",
            "name": "Triple Stack NLHE $20,000 GTD",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Fridays",
            "name": "Deep Stack Survivor $5,000 GTD",
            "start": "11:00am",
            "buyin": "$200"
          },
          {
            "day": "Fridays",
            "name": "Deep Stack Green Chip Bounty $10,000 GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Saturdays",
            "name": "Deep Stack NLHE",
            "start": "11:00am",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "Triple Stack NLHE $5,000 GTD",
            "start": "12:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "Harrah's Pompano Beach",
        "city": "Pompano Beach",
        "state": "FL",
        "schedules": [
          {
            "day": "Tuesdays",
            "name": "$200 NL Holdem",
            "start": "6:00pm",
            "buyin": "$200"
          }
        ]
      }
    ],
    "parent": {
      "to": "/florida-poker-rooms",
      "label": "All Florida poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Calder Casino",
        "city": "Miami Gardens",
        "state": "FL"
      },
      {
        "name": "Gulfstream Park Racing & Casino",
        "city": "Hallandale Beach",
        "state": "FL"
      }
    ]
  },
  "tampa-poker-rooms": {
    "title": "Tampa Bay Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Tampa Bay poker rooms and tournament schedules",
    "description": "Poker rooms in Tampa and St. Petersburg, with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in Tampa and St. Petersburg. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Tampa Bay poker rooms",
    "shortLabel": "Tampa Bay",
    "rooms": [
      {
        "name": "Derby Lane Poker Room",
        "city": "St. Petersburg",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$60 NLH $1.2K GTE",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "$70 NLH $6.5K GTE",
            "start": "6:30pm",
            "buyin": "$70"
          },
          {
            "day": "Tuesdays",
            "name": "$60 NLH $1.2K GTE",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "$180 NLH $16K GTE",
            "start": "6:30pm",
            "buyin": "$180"
          },
          {
            "day": "Wednesdays",
            "name": "$60 NLH $1.2K GTE",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "$55 NLH $5K GTE",
            "start": "6:30pm",
            "buyin": "$55"
          },
          {
            "day": "Thursdays",
            "name": "$60 NLH $1.2K GTE",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "$120 NLH $8K GTE $25 KO",
            "start": "6:30pm",
            "buyin": "$120"
          },
          {
            "day": "Fridays",
            "name": "$95 NLH $2K GTE $25 KO",
            "start": "11:00am",
            "buyin": "$95"
          },
          {
            "day": "Fridays",
            "name": "$120 NLH $12K GTE No Rake",
            "start": "6:30pm",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "$60 NLH $3.5K GTE",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Saturdays",
            "name": "$80 Deuces Wild $2K GTE $30 KO",
            "start": "6:30pm",
            "buyin": "$80"
          },
          {
            "day": "Sundays",
            "name": "$60 NLH $3.5K GTE",
            "start": "12:00pm",
            "buyin": "$60"
          }
        ]
      },
      {
        "name": "Lucky's Card Room (TGT Poker)",
        "city": "Tampa",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Weekly PLO $1K GTD",
            "start": "6:45pm",
            "buyin": "$50"
          },
          {
            "day": "Tuesdays",
            "name": "50/50 Tuesday $1K GTD",
            "start": "6:45pm",
            "buyin": "$55"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Mixed Games $1.5K GTD",
            "start": "11:30am",
            "buyin": "$160"
          },
          {
            "day": "Thursdays",
            "name": "99 Problems $9,999 GTD",
            "start": "6:45pm",
            "buyin": "$99"
          },
          {
            "day": "Fridays",
            "name": "Friday 50/50 $4K GTD",
            "start": "6:00pm",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "Twin River Hold'em",
            "start": "2:00pm",
            "buyin": "$50"
          },
          {
            "day": "Saturdays",
            "name": "Stratosphere Stack $4K GTD",
            "start": "6:45pm",
            "buyin": "$110"
          }
        ]
      },
      {
        "name": "Seminole Hard Rock Hotel & Casino, Tampa",
        "city": "Tampa",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Fridays",
            "name": "NLHE $2,000 GTD",
            "start": "11:00am",
            "buyin": "$100"
          },
          {
            "day": "Tuesdays",
            "name": "NLHE $3,000 GTD",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Wednesdays",
            "name": "PLO",
            "start": "6:00pm",
            "buyin": "$160"
          },
          {
            "day": "Thursdays",
            "name": "Deep Stack NLHE $3,000 GTD",
            "start": "11:00am",
            "buyin": "$150"
          },
          {
            "day": "Fridays",
            "name": "Quad Stack Double Green Chip Bounty NLHE $10,000 GTD",
            "start": "6:00pm",
            "buyin": "$150+$50"
          },
          {
            "day": "Saturdays",
            "name": "Triple 30s NLHE $30,000 GTD",
            "start": "11:00am",
            "buyin": "$250"
          },
          {
            "day": "Sundays",
            "name": "Monster Stack Black Chip Bounty NLHE $10,000 GTD",
            "start": "12:00pm",
            "buyin": "$200+$100"
          },
          {
            "day": "Sundays (alternating)",
            "name": "Bankroll Builder NLHE $10,000 GTD",
            "start": "12:00pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Tampa Bay Downs",
        "city": "Tampa",
        "state": "FL",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "$80 Super Stack",
            "start": "1:00pm",
            "buyin": "$80"
          },
          {
            "day": "Thursdays",
            "name": "$60 Satellite",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Fridays",
            "name": "$100 Super Stack",
            "start": "1:00pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "$60 Friday",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Saturdays",
            "name": "$120 Super Stack",
            "start": "1:00pm",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "$60 Super Stack",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "$60 Super Stack Blitz",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "$80 Super Stack",
            "start": "7:00pm",
            "buyin": "$80"
          },
          {
            "day": "Mondays",
            "name": "$60 Satellite",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "$180 Super Stack",
            "start": "6:00pm",
            "buyin": "$180"
          },
          {
            "day": "Tuesdays",
            "name": "$60 Super Stack Blitz",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "$85 Bay Area Poker Club",
            "start": "6:30pm",
            "buyin": "$85"
          },
          {
            "day": "Tuesdays",
            "name": "$45 Player Appreciation",
            "start": "7:00pm",
            "buyin": "$45"
          },
          {
            "day": "Wednesdays",
            "name": "$60 Super Stack Blitz",
            "start": "1:00pm",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "$125 Silks Bounty",
            "start": "7:00pm",
            "buyin": "$125"
          }
        ]
      }
    ],
    "parent": {
      "to": "/florida-poker-rooms",
      "label": "All Florida poker rooms"
    }
  },
  "seattle-poker-rooms": {
    "title": "Seattle Poker Tournaments Near You: Card Rooms | Daily Tourneys",
    "h1": "Poker tournaments near Seattle",
    "description": "Daily poker tournaments near Seattle at card rooms in Renton, Kirkland, Mountlake Terrace, Lakewood, Auburn, Everett, and Seattle: days, times, buy-ins.",
    "intro": "Looking for poker tournaments near Seattle? These are the Seattle area card rooms on file: Fortune Poker in Renton, Ace’s Poker in Mountlake Terrace and Lakewood, Casino Caribbean and Caribbean Cardroom in Kirkland, Imperial Palace in Auburn, Roxbury Lanes in Seattle, plus smaller rooms in Everett and Lake Stevens. Open a room for contact details and its daily and weekly tournaments. Daily and weekly events are listed under a room only when a schedule is on file. All 9 rooms here have a tournament schedule on file, with buy-ins from $25 to $200, and events on every day of the week.",
    "footerLabel": "Seattle area poker rooms",
    "shortLabel": "Seattle area",
    "rooms": [
      {
        "name": "Imperial Palace Casino Auburn",
        "city": "Auburn",
        "state": "WA",
        "schedules": [
          {
            "day": "Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "$50 NL Holdem",
            "start": "4:00pm",
            "buyin": "$50"
          }
        ]
      },
      {
        "name": "Broadway Grill & Pizzeria",
        "city": "Everett",
        "state": "WA",
        "schedules": [
          {
            "day": "Saturdays, Sundays",
            "name": "$40 NL Holdem",
            "start": "11:00am",
            "buyin": "$40"
          }
        ]
      },
      {
        "name": "Caribbean Cardroom",
        "city": "Kirkland",
        "state": "WA",
        "schedules": [
          {
            "day": "Tuesday, Wednesday, Thursday, Saturday, Sunday",
            "name": "Daily NLH",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Friday",
            "name": "Friday NLH",
            "start": "2:00pm",
            "buyin": "$130"
          }
        ]
      },
      {
        "name": "Casino Caribbean Kirkland",
        "city": "Kirkland",
        "state": "WA",
        "schedules": [
          {
            "day": "Sundays, Mondays, Tuesdays, Thursdays",
            "name": "$50 NLH",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Wednesdays",
            "name": "$50 Beat the Boss Bounty",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Mondays",
            "name": "$150 Green Chip Bounty",
            "start": "2:00pm",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$100 Green Chip Bounty",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "$150 NLH",
            "start": "12:00pm",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "$100 NLH",
            "start": "10:00am",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Razzals Bar & Grill",
        "city": "Lake Stevens",
        "state": "WA",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "$25 NL Holdem Bounty",
            "start": "7:00pm",
            "buyin": "$25"
          }
        ]
      },
      {
        "name": "Ace's Poker Lakewood",
        "city": "Lakewood",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
            "name": "$50 NL Holdem",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Fridays, Saturdays, Sundays",
            "name": "$120 NL Holdem",
            "start": "4:00pm",
            "buyin": "$120"
          }
        ]
      },
      {
        "name": "Ace's Poker Mountlake Terrace",
        "city": "Mountlake Terrace",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Sundays",
            "name": "No-Limit Hold'em",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Saturdays",
            "name": "No-Limit Hold'em",
            "start": "10:00am",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "No-Limit Hold'em",
            "start": "10:00am",
            "buyin": "$150"
          },
          {
            "day": "Saturdays",
            "name": "No-Limit Hold'em",
            "start": "2:00pm",
            "buyin": "$200"
          },
          {
            "day": "Mondays, Tuesdays",
            "name": "No-Limit Hold'em",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Green Chip Bounty",
            "start": "7:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Fortune Poker Renton",
        "city": "Renton",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "$60 NLH",
            "start": "8:30am",
            "buyin": "$60"
          },
          {
            "day": "Saturdays, Sundays",
            "name": "$60 NLH",
            "start": "8:30am",
            "buyin": "$60"
          }
        ]
      },
      {
        "name": "Roxbury Lanes Casino",
        "city": "Seattle",
        "state": "WA",
        "schedules": [
          {
            "day": "Wednesdays, Thursdays",
            "name": "$50 NL Holdem $200 Added",
            "start": "12:00pm",
            "buyin": "$50"
          }
        ]
      }
    ],
    "parent": {
      "to": "/washington-poker-rooms",
      "label": "All Washington poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Fortune Casino Renton",
        "city": "Renton",
        "state": "WA"
      },
      {
        "name": "Palace Casino Lakewood",
        "city": "Lakewood",
        "state": "WA"
      }
    ]
  },
  "phoenix-poker-rooms": {
    "title": "Poker Tournaments Near Phoenix: Daily Schedules | Daily Tourneys",
    "h1": "Poker tournaments near Phoenix",
    "description": "Daily poker tournaments near Phoenix at Talking Stick in Scottsdale, Lone Butte in Chandler, and Desert Diamond in Glendale: days, times, and buy-ins.",
    "intro": "Looking for poker tournaments near Phoenix? The Phoenix area poker rooms on file are Talking Stick Resort in Scottsdale, Lone Butte Casino in Chandler, and Desert Diamond Casino West Valley in Glendale. Open a room for contact details and its daily and weekly tournaments. Daily and weekly events are listed under a room only when a schedule is on file. All 3 rooms here have a tournament schedule on file, with buy-ins from $85 to $400, and events on every day of the week.",
    "footerLabel": "Phoenix area poker rooms",
    "shortLabel": "Phoenix area",
    "rooms": [
      {
        "name": "Lone Butte Casino",
        "city": "Chandler",
        "state": "AZ",
        "schedules": [
          {
            "day": "Saturdays",
            "name": "Monster Stack",
            "start": "10:00am",
            "buyin": "$400"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Sundays",
            "name": "No Limit Hold'em",
            "start": "11:00am",
            "buyin": "$85"
          },
          {
            "day": "Wednesdays, Thursdays",
            "name": "No Limit Hold'em",
            "start": "6:30pm",
            "buyin": "$85"
          }
        ]
      },
      {
        "name": "Desert Diamond Casino, West Valley",
        "city": "Glendale",
        "state": "AZ",
        "schedules": [
          {
            "day": "Fridays",
            "name": "Friday Morning NLHE",
            "start": "10am",
            "buyin": "$130"
          }
        ]
      },
      {
        "name": "Talking Stick",
        "city": "Scottsdale",
        "state": "AZ",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "Weekday Morning NLHE",
            "start": "11:15am",
            "buyin": "$125"
          },
          {
            "day": "Tuesdays, Fridays",
            "name": "Evening NLHE",
            "start": "7:15pm",
            "buyin": "$200"
          },
          {
            "day": "Wednesdays",
            "name": "Crazy Pineapple",
            "start": "7:15pm"
          },
          {
            "day": "Thursdays",
            "name": "Progressive Bounty NLHE",
            "start": "7:15pm"
          },
          {
            "day": "Saturdays",
            "name": "Super Stack NLHE",
            "start": "7:15pm"
          }
        ]
      }
    ]
  },
  "jacksonville-poker-rooms": {
    "title": "Jacksonville Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Jacksonville poker rooms and tournament schedules",
    "description": "Poker rooms in Jacksonville, Orange Park, and St. Augustine, with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in Jacksonville, Orange Park, and St. Augustine. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Jacksonville poker rooms",
    "shortLabel": "Jacksonville",
    "rooms": [
      {
        "name": "bestbet Jacksonville",
        "city": "Jacksonville",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$200"
          }
        ]
      },
      {
        "name": "Bestbet, Orange Park",
        "city": "Orange Park",
        "state": "FL",
        "schedules": [
          {
            "day": "Sundays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "bestbet St. Augustine",
        "city": "St. Augustine",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "Weekly NLH",
            "start": "7:00pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Fridays",
            "name": "Six Hour Ironman NLH",
            "start": "7:00pm",
            "buyin": "$160"
          },
          {
            "day": "Saturdays",
            "name": "Weekly NLH",
            "start": "12:00pm",
            "buyin": "$100"
          }
        ]
      }
    ],
    "parent": {
      "to": "/florida-poker-rooms",
      "label": "All Florida poker rooms"
    }
  },
  "sacramento-poker-rooms": {
    "title": "Sacramento Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Sacramento area poker rooms and tournament schedules",
    "description": "Sacramento area poker rooms in Sacramento, Citrus Heights, Rancho Cordova, and El Dorado Hills, with schedules on file.",
    "intro": "Poker rooms on file in Sacramento, Citrus Heights, Rancho Cordova, and El Dorado Hills. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Sacramento area poker rooms",
    "shortLabel": "Sacramento area",
    "rooms": [
      {
        "name": "Stones Gambling Hall",
        "city": "Citrus Heights",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Thursdays",
            "name": "$60 NLH",
            "start": "10:30am",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday $60 NLH",
            "start": "10:30am",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$100 NLH",
            "start": "6:30pm",
            "buyin": "$100"
          },
          {
            "day": "Saturdays",
            "name": "Saturday $100 NLH",
            "start": "10:30am",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "El Dorado Hills Casino",
        "city": "El Dorado Hills",
        "state": "CA",
        "schedules": [
          {
            "day": "Saturdays",
            "name": "Deep Stack Saturdays $4K GTD",
            "start": "3:00pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "Super Sunday Bankroll Builder",
            "start": "3:00pm",
            "buyin": "$60"
          }
        ]
      },
      {
        "name": "Capitol Casino",
        "city": "Sacramento",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Fridays",
            "name": "Daily NLH",
            "start": "10:10am",
            "buyin": "$35"
          },
          {
            "day": "Tuesdays, Wednesdays, Thursdays",
            "name": "Daily NLH",
            "start": "10:10am",
            "buyin": "$35"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Deep Stack $100",
            "start": "10:10am",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "$3,000 Guaranteed",
            "start": "10:10am",
            "buyin": "$60"
          }
        ]
      },
      {
        "name": "Parkwest Casino Cordova",
        "city": "Rancho Cordova",
        "state": "CA",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Limelight Cardroom",
        "city": "Sacramento",
        "state": "CA"
      }
    ]
  },
  "san-antonio-poker-rooms": {
    "title": "San Antonio Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "San Antonio poker rooms and tournament schedules",
    "description": "Poker rooms in San Antonio with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in San Antonio. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "San Antonio poker rooms",
    "shortLabel": "San Antonio",
    "rooms": [
      {
        "name": "Alamo City Poker Club",
        "city": "San Antonio",
        "state": "TX",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "Thursday Ladies' Night NLH",
            "start": "7:00pm",
            "buyin": "$60"
          },
          {
            "day": "Sundays (third each month)",
            "name": "King of Kings Complimentary Tournament",
            "buyin": "Free"
          }
        ]
      },
      {
        "name": "The Lodge Card Club San Antonio",
        "city": "San Antonio",
        "state": "TX",
        "schedules": [
          {
            "day": "Sundays",
            "name": "$30 Nightly Freeroll $1K GTD",
            "start": "4:15pm",
            "buyin": "$30"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$30 Nightly Freeroll $1K GTD",
            "start": "8:30pm",
            "buyin": "$30"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Night Freezeout $5K GTD",
            "start": "6:15pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays",
            "name": "Monday Night Poker $2K GTD",
            "start": "7:15pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "SA Card House",
        "city": "San Antonio",
        "state": "TX",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/texas-poker-rooms",
      "label": "All Texas poker rooms"
    }
  },
  "bay-area-poker-rooms": {
    "title": "San Francisco Bay Area Poker Rooms & Schedules | Daily Tourneys",
    "h1": "San Francisco Bay Area poker rooms and tournament schedules",
    "description": "Bay Area card rooms in San Jose, Colma, San Rafael, Livermore, Antioch, Rohnert Park, and Gilroy, with daily and weekly tournament schedules on file.",
    "intro": "Card rooms and casino poker rooms around the San Francisco Bay Area: San Jose, Colma, San Rafael, Livermore, Antioch, Rohnert Park, and Gilroy. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Bay Area poker rooms",
    "shortLabel": "Bay Area",
    "rooms": [
      {
        "name": "Nineteenth Hole",
        "city": "Antioch",
        "state": "CA",
        "schedules": [
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "1:00pm",
            "buyin": "$55"
          },
          {
            "day": "Saturdays",
            "name": "NLH Free Roll",
            "start": "1:00pm",
            "buyin": "$5"
          },
          {
            "day": "Tuesdays",
            "name": "NLH Free Roll",
            "start": "5:30pm",
            "buyin": "$5"
          }
        ]
      },
      {
        "name": "Lucky Chances",
        "city": "Colma",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays, Thursdays",
            "name": "$165 NL Holdem",
            "start": "9:30am",
            "buyin": "$165"
          },
          {
            "day": "Fridays, Saturdays",
            "name": "$240 NL Holdem",
            "start": "9:30am",
            "buyin": "$240"
          },
          {
            "day": "Sundays",
            "name": "$300 NL Holdem",
            "start": "9:30am",
            "buyin": "$300"
          }
        ]
      },
      {
        "name": "Garlic City Casino & Restaurant",
        "city": "Gilroy",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays",
            "name": "Wednesday NLH $50",
            "start": "11:00am",
            "buyin": "$50"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLH $90",
            "start": "11:00am",
            "buyin": "$90"
          }
        ]
      },
      {
        "name": "Livermore Casino",
        "city": "Livermore",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays",
            "name": "Wednesday Hold'em",
            "start": "10:00am",
            "buyin": "$85"
          },
          {
            "day": "Sundays",
            "name": "Sunday Morning Showdown",
            "start": "10:00am",
            "buyin": "$130"
          }
        ]
      },
      {
        "name": "Graton Resort & Casino",
        "city": "Rohnert Park",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Wednesdays, Fridays",
            "name": "Daily Events $135",
            "start": "10:00am",
            "buyin": "$135"
          },
          {
            "day": "Tuesdays",
            "name": "Daily Events $135",
            "start": "6:00pm",
            "buyin": "$135"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Weekly $65 Turbo",
            "start": "10:00am",
            "buyin": "$65"
          },
          {
            "day": "Thursdays",
            "name": "Green Chip Bounty $200",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "Sunday Weekly $250 Black Chip Bounty",
            "start": "10:00am",
            "buyin": "$250"
          }
        ]
      },
      {
        "name": "Bay 101",
        "city": "San Jose",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Daily NLH Mystery Bounty",
            "start": "9:15am",
            "buyin": "$250 ($155+$50+$15+$25+$5)"
          },
          {
            "day": "Tuesdays",
            "name": "Daily NLH",
            "start": "9:15am",
            "buyin": "$200 ($155+$15+$25+$5)"
          },
          {
            "day": "Wednesdays",
            "name": "Daily NLH",
            "start": "9:15am",
            "buyin": "$200 ($155+$15+$25+$5)"
          },
          {
            "day": "Thursdays",
            "name": "Daily NLH",
            "start": "9:15am",
            "buyin": "$200 ($155+$15+$25+$5)"
          },
          {
            "day": "Fridays",
            "name": "Friday OneDay1K Satellite Turbo",
            "start": "8:30am",
            "buyin": "$200 ($160+$15+$25)"
          },
          {
            "day": "Saturdays",
            "name": "Saturday OneDay $1K",
            "start": "8:30am",
            "buyin": "$1000 ($900+$50+$45+$5)"
          },
          {
            "day": "Sundays",
            "name": "Daily NLH",
            "start": "9:15am",
            "buyin": "$200 ($155+$15+$25+$5)"
          }
        ]
      },
      {
        "name": "Club San Rafael",
        "city": "San Rafael",
        "state": "CA",
        "schedules": [
          {
            "day": "Saturdays",
            "name": "NLH Bounty",
            "start": "3:00pm",
            "buyin": "$300"
          },
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "4:30pm",
            "buyin": "$220"
          },
          {
            "day": "Mondays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$100"
          }
        ]
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Casino M8trix",
        "city": "San Jose",
        "state": "CA"
      }
    ]
  },
  "central-valley-poker-rooms": {
    "title": "Central Valley CA Poker Rooms & Schedules | Daily Tourneys",
    "h1": "California Central Valley poker rooms and tournament schedules",
    "description": "Central Valley card rooms in Lodi, Tracy, Manteca, Turlock, Merced, Fresno, Delano, and Bakersfield, with daily and weekly tournament schedules on file.",
    "intro": "Card rooms along the California Central Valley from Lodi and Tracy south through Manteca, Turlock, Merced, Fresno, Delano, and Bakersfield. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Central Valley poker rooms",
    "shortLabel": "Central Valley",
    "rooms": [
      {
        "name": "Golden West Casino",
        "city": "Bakersfield",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays",
            "name": "$80 Wednesday NLH",
            "start": "6:15pm",
            "buyin": "$80"
          },
          {
            "day": "Saturdays",
            "name": "$100 Saturday NLH",
            "start": "12:15pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "The Aviator Casino",
        "city": "Delano",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays",
            "name": "Mexican Poker",
            "start": "6:00pm",
            "buyin": "$30"
          }
        ]
      },
      {
        "name": "Club One Casino",
        "city": "Fresno",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Monday Madness $3,000 GTD",
            "start": "10:15am",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Nights W/Ted $6,000 GTD",
            "start": "6:15pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "Live Action Wednesdays $500",
            "start": "10:15am",
            "buyin": "$0"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Night $3,000 GTD",
            "start": "6:15pm",
            "buyin": "$60"
          },
          {
            "day": "Fridays",
            "name": "Friday Road to Riches $5,000 GTD",
            "start": "10:15am",
            "buyin": "$60"
          },
          {
            "day": "Saturdays",
            "name": "Saturday Morning Omaha 8+ $2,500 GTD",
            "start": "10:15am",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "Sunday High Roller $10,000 GTD",
            "start": "12:15pm",
            "buyin": "$120"
          }
        ]
      },
      {
        "name": "Parkwest Casino Lodi",
        "city": "Lodi",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "3K Qualifier NLH",
            "start": "10:00am",
            "buyin": "$40"
          },
          {
            "day": "Wednesdays",
            "name": "3K Qualifier NLH",
            "start": "10:00am",
            "buyin": "$40"
          },
          {
            "day": "Wednesdays",
            "name": "2K Guaranteed NLH",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Fridays",
            "name": "Bounty Hunter NLH",
            "start": "10:00am",
            "buyin": "$75"
          },
          {
            "day": "Sundays",
            "name": "3K Qualifier NLH",
            "start": "11:00am",
            "buyin": "$40"
          },
          {
            "day": "1st Saturdays",
            "name": "$3,000 Guaranteed Championship NLH",
            "buyin": "$80"
          }
        ]
      },
      {
        "name": "Merced Poker Room",
        "city": "Merced",
        "state": "CA",
        "schedules": [
          {
            "day": "Saturdays",
            "name": "Saturday Tournament",
            "start": "1:00pm",
            "buyin": "$32"
          },
          {
            "day": "Wednesdays",
            "name": "Wednesday Tournament",
            "start": "6:00pm",
            "buyin": "$52"
          }
        ]
      },
      {
        "name": "Stars Casino",
        "city": "Tracy",
        "state": "CA",
        "schedules": [
          {
            "day": "Sundays",
            "name": "$20 NL Poker Tournament",
            "start": "10:00am",
            "buyin": "$20"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
            "name": "$80 NLH $1,000 Guaranteed",
            "start": "12:00pm",
            "buyin": "$80"
          },
          {
            "day": "Fridays",
            "name": "$160 Bounty NLH",
            "start": "12:00pm",
            "buyin": "$160"
          }
        ]
      },
      {
        "name": "Turlock Poker Room",
        "city": "Turlock",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$35 NLH Turbo",
            "start": "10:00am",
            "buyin": "$35"
          },
          {
            "day": "Mondays",
            "name": "$50 NLH",
            "start": "6:00pm",
            "buyin": "$50"
          },
          {
            "day": "Tuesdays",
            "name": "$45 NLH Bounty",
            "start": "10:00am",
            "buyin": "$45"
          },
          {
            "day": "Wednesdays",
            "name": "$35 NLH Turbo",
            "start": "10:00am",
            "buyin": "$35"
          },
          {
            "day": "Wednesdays",
            "name": "$70 NLH",
            "start": "6:00pm",
            "buyin": "$70"
          },
          {
            "day": "Thursdays",
            "name": "$45 NLH Bounty",
            "start": "10:00am",
            "buyin": "$45"
          },
          {
            "day": "Fridays",
            "name": "$35 NLH Turbo",
            "start": "10:00am",
            "buyin": "$35"
          },
          {
            "day": "Saturdays",
            "name": "$50 NLH",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Sundays",
            "name": "$45 NLH Bounty",
            "start": "10:00am",
            "buyin": "$45"
          },
          {
            "day": "Sundays",
            "name": "$160 NLH Mega Satellite",
            "start": "6:00pm",
            "buyin": "$160"
          }
        ]
      },
      {
        "name": "Parkwest Casino Manteca",
        "city": "Manteca",
        "state": "CA",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    }
  },
  "central-florida-poker-rooms": {
    "title": "Central Florida Poker Rooms & Schedules | Daily Tourneys",
    "h1": "Central Florida poker rooms and tournament schedules",
    "description": "Central Florida poker rooms in Daytona Beach, Orange City, Ocala, Summerfield, and Melbourne, with daily and weekly tournament schedules on file.",
    "intro": "Poker rooms in Daytona Beach, Orange City, Ocala, Summerfield, and Melbourne, the card rooms within driving distance of Orlando. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Central Florida poker rooms",
    "shortLabel": "Central Florida",
    "rooms": [
      {
        "name": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
        "city": "Daytona Beach",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$80 Double Board Bomb Pot NLH",
            "start": "12:10pm",
            "buyin": "$80"
          },
          {
            "day": "Tuesdays",
            "name": "$100 Green Chip Bounty NLH",
            "start": "12:10pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "$100 Double Stack Turbo NLH",
            "start": "7:10pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "$80 Crazy Pineapple",
            "start": "12:10pm",
            "buyin": "$80"
          },
          {
            "day": "Fridays",
            "name": "$130 GAPT Seniors 50+ NLH",
            "start": "12:10pm",
            "buyin": "$130"
          },
          {
            "day": "Fridays",
            "name": "$165 GAPT Friday Night Lights NLH",
            "start": "7:10pm",
            "buyin": "$165"
          },
          {
            "day": "Saturdays",
            "name": "$130 Deep Stack NLH",
            "start": "12:10pm",
            "buyin": "$130"
          },
          {
            "day": "Sundays",
            "name": "$165 GAPT Road To The Championship NLH",
            "start": "12:10pm",
            "buyin": "$165"
          },
          {
            "day": "Saturdays",
            "name": "$100 Double Board Bomb Pot",
            "start": "7:10pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Club 52 Poker at Melbourne Greyhound Park",
        "city": "Melbourne",
        "state": "FL",
        "schedules": [
          {
            "day": "Thursdays",
            "name": "Crazy Pineapple",
            "start": "11:00am",
            "buyin": "$45"
          },
          {
            "day": "Fridays",
            "name": "Omaha Hi-Lo",
            "start": "11:00am",
            "buyin": "$70"
          },
          {
            "day": "Fridays",
            "name": "Friday Night",
            "start": "6:30pm",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "Sunday Mega Stack",
            "start": "12:00pm",
            "buyin": "$130"
          },
          {
            "day": "Mondays",
            "name": "No-Limit Hold'em",
            "start": "6:30pm",
            "buyin": "$60"
          },
          {
            "day": "Tuesdays",
            "name": "Deuces Wild",
            "start": "11:00am",
            "buyin": "$45"
          },
          {
            "day": "Wednesdays",
            "name": "Turbo",
            "start": "6:30pm",
            "buyin": "$70"
          }
        ]
      },
      {
        "name": "Ocala Bets",
        "city": "Ocala",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Double Board Bomb Pot $60",
            "start": "11:00am",
            "buyin": "$60"
          },
          {
            "day": "Mondays",
            "name": "FreeRoll $500 GTD",
            "start": "6:00pm",
            "buyin": "$0"
          },
          {
            "day": "Tuesdays",
            "name": "Reba's Re-Buy Rumble $50",
            "start": "11:00am",
            "buyin": "$50"
          },
          {
            "day": "Tuesdays",
            "name": "DBBP Bounty $80",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Wednesdays",
            "name": "Mega Monster Stack $50",
            "start": "11:00am",
            "buyin": "$50"
          },
          {
            "day": "Fridays",
            "name": "The Original $1,000 1st Place GTD",
            "start": "7:00pm",
            "buyin": "$65"
          },
          {
            "day": "Sundays",
            "name": "Brunch Buster GTD",
            "start": "11:00am",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Orange City Racing and Card Club",
        "city": "Orange City",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$130 Triple Stack Turbo NLH",
            "start": "7:10pm",
            "buyin": "$130"
          },
          {
            "day": "Tuesdays",
            "name": "$100 Double Board Bomb Pot NLH",
            "start": "7:10pm",
            "buyin": "$100"
          },
          {
            "day": "Wednesdays",
            "name": "$130 Deep Stack NLH",
            "start": "12:10pm",
            "buyin": "$130"
          },
          {
            "day": "Thursdays",
            "name": "$100 GAPT Double Stack Turbo NLH",
            "start": "7:10pm",
            "buyin": "$100"
          },
          {
            "day": "Fridays",
            "name": "$165 GAPT Double Green Chip Bounty NLH",
            "start": "3:10pm",
            "buyin": "$165"
          },
          {
            "day": "Saturdays",
            "name": "$100 PLO High Only Double Board Bomb Pot",
            "start": "12:10pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "$100 Green Chip Bounty NLH",
            "start": "7:10pm",
            "buyin": "$100"
          },
          {
            "day": "1st Thursdays",
            "name": "OC Monthly Tournament",
            "start": "7:10pm"
          }
        ]
      },
      {
        "name": "Oxford Downs",
        "city": "Summerfield",
        "state": "FL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Shirley's Seniors NLH (50+)",
            "start": "11:15am",
            "buyin": "$35"
          },
          {
            "day": "Mondays",
            "name": "Monday Night NLH Turbo",
            "start": "6:15pm",
            "buyin": "$45"
          },
          {
            "day": "Fridays",
            "name": "Friday Duckie's NLH",
            "start": "10:15am",
            "buyin": "$35"
          },
          {
            "day": "Fridays",
            "name": "Friday Night Green Chip Bounty NLH",
            "start": "6:15pm",
            "buyin": "$135"
          },
          {
            "day": "Sundays",
            "name": "Super Deep Stack NLH",
            "start": "11:15am",
            "buyin": "$65"
          },
          {
            "day": "Sundays",
            "name": "Sunday Night Deep Stack Turbo NLH",
            "start": "6:15pm",
            "buyin": "$65"
          },
          {
            "day": "Last Saturdays",
            "name": "Monster Stack NLH",
            "start": "11:15am",
            "buyin": "$200"
          }
        ]
      }
    ],
    "parent": {
      "to": "/florida-poker-rooms",
      "label": "All Florida poker rooms"
    }
  },
  "eastern-washington-poker-rooms": {
    "title": "Spokane & Eastern Washington Poker Rooms | Daily Tourneys",
    "h1": "Spokane and Eastern Washington poker rooms and tournament schedules",
    "description": "Eastern Washington card rooms in Spokane, Spokane Valley, the Tri-Cities, Yakima, East Wenatchee, and Clarkston, with daily and weekly tournament schedules on file.",
    "intro": "Card rooms east of the Cascades: Spokane, Spokane Valley, Pasco, Richland, Yakima, East Wenatchee, and Clarkston. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Eastern Washington poker rooms",
    "shortLabel": "Eastern Washington",
    "rooms": [
      {
        "name": "Lancer Lanes and Casino",
        "city": "Clarkston",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "WSOP Satellite",
            "start": "6:30pm",
            "buyin": "$60"
          }
        ]
      },
      {
        "name": "Buzz Inn Steakhouse East Wenatchee",
        "city": "East Wenatchee",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Thursdays",
            "name": "Freeroll NL Holdem",
            "start": "6:00pm",
            "buyin": "Free"
          },
          {
            "day": "Tuesdays",
            "name": "$55 NLH Deepstack",
            "start": "6:00pm",
            "buyin": "$55"
          },
          {
            "day": "Wednesdays",
            "name": "$50 NL Holdem",
            "start": "6:00pm",
            "buyin": "$50"
          },
          {
            "day": "Fridays",
            "name": "$60 NL Holdem",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Sundays",
            "name": "$100 NLH w/Add-On",
            "start": "6:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Clearwater Saloon & Casino",
        "city": "East Wenatchee",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays",
            "name": "Afternoon Freeroll",
            "start": "1:00pm",
            "buyin": "Free"
          },
          {
            "day": "Mondays, Tuesdays, Thursdays, Fridays",
            "name": "Evening Freeroll",
            "start": "6:00pm",
            "buyin": "Free"
          },
          {
            "day": "Wednesdays",
            "name": "$27 Satellite to Monthly $10K",
            "start": "1:00pm",
            "buyin": "$27"
          }
        ]
      },
      {
        "name": "Crazy Moose Casino Pasco",
        "city": "Pasco",
        "state": "WA",
        "schedules": [
          {
            "day": "Sundays, Mondays, Wednesdays, Thursdays, Fridays",
            "name": "$40 NLH",
            "start": "10:00am",
            "buyin": "$40"
          },
          {
            "day": "Tuesdays",
            "name": "$40 Tuesday Tahoe",
            "start": "10:00am",
            "buyin": "$40"
          },
          {
            "day": "Saturdays",
            "name": "$120 Saturday NLH",
            "start": "10:00am",
            "buyin": "$120"
          },
          {
            "day": "Mondays, Wednesdays, Thursdays, Fridays, Saturdays",
            "name": "$40 NLH",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Tuesdays",
            "name": "$40 Tuesday Tahoe",
            "start": "6:00pm",
            "buyin": "$40"
          }
        ]
      },
      {
        "name": "Joker's Casino and Sports Bar",
        "city": "Richland",
        "state": "WA",
        "schedules": [
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "1:00pm",
            "buyin": "$70"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "1:00pm",
            "buyin": "$100"
          },
          {
            "day": "Mondays, Wednesdays, Thursdays",
            "name": "NLH",
            "start": "3:00pm",
            "buyin": "$50"
          },
          {
            "day": "Tuesdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$70"
          }
        ]
      },
      {
        "name": "Lilac Lanes & Casino",
        "city": "Spokane",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Wednesdays",
            "name": "$40 NLH",
            "start": "10:30am",
            "buyin": "$40"
          },
          {
            "day": "Tuesdays, Thursdays",
            "name": "$40 Bounty",
            "start": "10:30am",
            "buyin": "$40"
          },
          {
            "day": "Fridays",
            "name": "$40 NLH",
            "start": "10:30am",
            "buyin": "$40"
          },
          {
            "day": "Mondays, Wednesdays",
            "name": "$25 NLH",
            "start": "7:00pm",
            "buyin": "$25"
          },
          {
            "day": "Tuesdays",
            "name": "$40 Bounty",
            "start": "7:00pm",
            "buyin": "$40"
          },
          {
            "day": "Thursdays",
            "name": "$40 Industry Night",
            "start": "7:00pm",
            "buyin": "$40"
          },
          {
            "day": "Fridays",
            "name": "$75 NLH",
            "start": "7:00pm",
            "buyin": "$75"
          },
          {
            "day": "Saturdays, Sundays",
            "name": "$50 NLH",
            "start": "1:00pm",
            "buyin": "$50"
          },
          {
            "day": "Saturdays",
            "name": "$40 NLH",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Sundays",
            "name": "$25 NLH",
            "start": "6:00pm",
            "buyin": "$25"
          }
        ]
      },
      {
        "name": "Black Pearl Restaurant & Card Room",
        "city": "Spokane Valley",
        "state": "WA",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
            "name": "$25 NLH",
            "start": "10:00am",
            "buyin": "$25"
          },
          {
            "day": "Saturdays, Sundays",
            "name": "$50 NLH",
            "start": "10:00am",
            "buyin": "$50"
          },
          {
            "day": "Wednesdays, Sundays",
            "name": "$30 NLH",
            "start": "6:00pm",
            "buyin": "$30"
          }
        ]
      },
      {
        "name": "Casino Caribbean Yakima",
        "city": "Yakima",
        "state": "WA",
        "schedules": [
          {
            "day": "Saturdays, Sundays",
            "name": "Weekend Noon NLH $120 ($2K GTD)",
            "start": "12:00pm",
            "buyin": "$120"
          },
          {
            "day": "Mondays, Wednesdays, Fridays",
            "name": "MWF Evening NLH $65",
            "start": "7:00pm",
            "buyin": "$65"
          }
        ]
      }
    ],
    "parent": {
      "to": "/washington-poker-rooms",
      "label": "All Washington poker rooms"
    }
  },
  "central-coast-poker-rooms": {
    "title": "California Central Coast Poker Rooms & Schedules | Daily Tourneys",
    "h1": "California Central Coast poker rooms and tournament schedules",
    "description": "Central Coast card rooms in Santa Cruz, Atascadero, Grover Beach, and Ventura, with daily and weekly tournament schedules on file.",
    "intro": "Card rooms along the California coast between the Bay Area and Los Angeles: Santa Cruz, Atascadero, Grover Beach, and Ventura. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Central Coast poker rooms",
    "shortLabel": "Central Coast",
    "rooms": [
      {
        "name": "Outlaws Card Parlour",
        "city": "Atascadero",
        "state": "CA",
        "schedules": [
          {
            "day": "Wednesdays",
            "name": "$20 NLH Rebuy Tournament",
            "start": "6:00pm",
            "buyin": "$20"
          },
          {
            "day": "Saturdays",
            "name": "$120 Freezeout Hold'em Tournament",
            "start": "4:00pm",
            "buyin": "$120"
          },
          {
            "day": "Saturdays",
            "name": "$40 NLH Tournament",
            "start": "6:00pm",
            "buyin": "$40"
          },
          {
            "day": "Sundays",
            "name": "$40 NLH Rebuy Tournament",
            "start": "6:00pm",
            "buyin": "$40"
          }
        ]
      },
      {
        "name": "Central Coast Casino",
        "city": "Grover Beach",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$20/$20 NLH Tournament",
            "start": "4:00pm",
            "buyin": "$20"
          },
          {
            "day": "Fridays",
            "name": "$100/$60 NLH Tournament",
            "start": "4:00pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "Survival Sunday $100/$20 Freezeout",
            "start": "10:00am",
            "buyin": "$100"
          },
          {
            "day": "1st Wednesday",
            "name": "1st Wednesday Monthly $100 NLH",
            "start": "5:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Oceanview Card Room",
        "city": "Santa Cruz",
        "state": "CA",
        "schedules": [
          {
            "day": "Saturdays (1st of month)",
            "name": "1st Saturday",
            "start": "3:30pm",
            "buyin": "$190"
          },
          {
            "day": "Sundays (1st of month)",
            "name": "1st Sunday",
            "start": "3:30pm",
            "buyin": "$190"
          },
          {
            "day": "Tuesdays (1st of month)",
            "name": "1st Tuesday",
            "start": "5:00pm",
            "buyin": "$190"
          }
        ]
      },
      {
        "name": "Players Casino",
        "city": "Ventura",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "$150 NLHE Bounty",
            "start": "6:00pm",
            "buyin": "$150"
          },
          {
            "day": "Tuesdays",
            "name": "$60 NLHE",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "$60 NLHE",
            "start": "12:00pm",
            "buyin": "$60"
          },
          {
            "day": "Thursdays",
            "name": "$180 NLHE",
            "start": "6:00pm",
            "buyin": "$180"
          },
          {
            "day": "Sundays",
            "name": "$180 NLHE",
            "start": "12:00pm",
            "buyin": "$180"
          },
          {
            "day": "Sundays",
            "name": "$60 NLHE",
            "start": "6:00pm",
            "buyin": "$60"
          }
        ]
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    }
  },
  "northern-california-poker-rooms": {
    "title": "Northern California Poker Rooms & Schedules | Daily Tourneys",
    "h1": "Northern California poker rooms and tournament schedules",
    "description": "Far Northern California card rooms in Redding, Chico, Grass Valley, Eureka, and Loleta, with daily and weekly tournament schedules on file.",
    "intro": "Card rooms north of Sacramento: Redding, Chico, Grass Valley, and the Humboldt County rooms in Eureka and Loleta. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Northern California poker rooms",
    "shortLabel": "Northern California",
    "rooms": [
      {
        "name": "Casino 99",
        "city": "Chico",
        "state": "CA",
        "schedules": [
          {
            "day": "Mondays, Wednesdays, Thursdays, Saturdays",
            "name": "$35 NL Holdem",
            "start": "10:00am",
            "buyin": "$35"
          },
          {
            "day": "Sundays",
            "name": "$45 NL Holdem",
            "start": "5:00pm",
            "buyin": "$45"
          },
          {
            "day": "Tuesdays, Fridays",
            "name": "$35 NL Holdem Rebuy",
            "start": "10:00am",
            "buyin": "$35"
          }
        ]
      },
      {
        "name": "Towers Casino & Card Room",
        "city": "Grass Valley",
        "state": "CA",
        "schedules": [
          {
            "day": "Sundays",
            "name": "Lucky Re-Buy Sunday NLH",
            "start": "3:00pm",
            "buyin": "$50"
          },
          {
            "day": "Sundays (first each month)",
            "name": "Super Sunday NLH (1st Sunday)",
            "start": "3:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "Bear River Casino Hotel",
        "city": "Loleta",
        "state": "CA",
        "schedules": [
          {
            "day": "Fridays, Saturdays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$60"
          },
          {
            "day": "Wednesdays",
            "name": "Green Chip Bounty",
            "start": "6:00pm",
            "buyin": "$100"
          }
        ]
      },
      {
        "name": "Casino Club",
        "city": "Redding",
        "state": "CA",
        "schedules": [
          {
            "day": "Tuesdays",
            "name": "Tuesday NLH $80",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Deepstack NLH $80",
            "start": "6:00pm",
            "buyin": "$80"
          },
          {
            "day": "Sundays",
            "name": "Sunday NLH $70",
            "start": "4:00pm",
            "buyin": "$70"
          },
          {
            "day": "Saturdays (third each month)",
            "name": "Monthly NLH $150 (3rd Saturday)",
            "start": "4:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "North Coast Casino",
        "city": "Eureka",
        "state": "CA",
        "schedules": []
      }
    ],
    "parent": {
      "to": "/california-poker-rooms",
      "label": "All California poker rooms"
    },
    "alsoRooms": [
      {
        "name": "Casino Chico",
        "city": "Chico",
        "state": "CA"
      }
    ]
  },
  "pennsylvania-poker-rooms": {
    "title": "Pennsylvania Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Pennsylvania poker rooms and casino tournaments",
    "description": "Pennsylvania casino poker rooms in Bensalem, Bethlehem, Pittsburgh, and Wilkes-Barre, with daily and weekly tournament schedules on file.",
    "intro": "Casino poker rooms in Bensalem, Bethlehem, Pittsburgh, and Wilkes-Barre. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Pennsylvania poker rooms",
    "shortLabel": "Pennsylvania",
    "rooms": [
      {
        "name": "Parx Casino",
        "city": "Bensalem",
        "state": "PA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Double Green Chip Bounty",
            "start": "6:15pm",
            "buyin": "$200"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "11:15am",
            "buyin": "$340"
          },
          {
            "day": "Sundays",
            "name": "Turbo",
            "start": "11:15am",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "The Sands Casino, Bethlehem",
        "city": "Bethlehem",
        "state": "PA",
        "schedules": [
          {
            "day": "Sundays",
            "name": "Sunday Black Chip Bounty NLH",
            "start": "11:15am",
            "buyin": "$150+$100 bounty"
          },
          {
            "day": "Mondays",
            "name": "Monday Green Chip Bounty NLH",
            "start": "11:15am",
            "buyin": "$100+$25 bounty"
          },
          {
            "day": "Tuesdays",
            "name": "Tuesday Progressive Bounty NLH",
            "start": "7:15pm",
            "buyin": "$100+$25+$25"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Green Chip Bounty NLH",
            "start": "7:15pm",
            "buyin": "$100+$25 bounty"
          },
          {
            "day": "Fridays",
            "name": "Friday Progressive Bounty NLH",
            "start": "11:15am",
            "buyin": "$100+$25+$25"
          }
        ]
      },
      {
        "name": "Rivers Casino",
        "city": "Pittsburgh",
        "state": "PA",
        "schedules": [
          {
            "day": "Fridays, Sundays",
            "name": "NLH",
            "start": "12:00pm",
            "buyin": "$125"
          },
          {
            "day": "Wednesdays",
            "name": "Double Green Chip Bounty",
            "start": "4:00pm",
            "buyin": "$160"
          },
          {
            "day": "Fridays",
            "name": "Deep Stack Turbo",
            "start": "7:00pm",
            "buyin": "$150"
          }
        ]
      },
      {
        "name": "Mohegan Sun Pocono",
        "city": "Wilkes-Barre",
        "state": "PA",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Double Green Chip Bounty",
            "start": "7:00pm",
            "buyin": "$150"
          },
          {
            "day": "Wednesdays, Fridays",
            "name": "Green Chip Bounty",
            "start": "7:00pm",
            "buyin": "$125"
          }
        ]
      }
    ]
  },
  "michigan-poker-rooms": {
    "title": "Michigan Poker Rooms & Tournament Schedules | Daily Tourneys",
    "h1": "Michigan poker rooms and casino tournaments",
    "description": "Michigan casino poker rooms in Detroit, Battle Creek, Mount Pleasant, and Wayland, with daily and weekly tournament schedules on file.",
    "intro": "Casino poker rooms in Detroit, Battle Creek, Mount Pleasant, and Wayland. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Michigan poker rooms",
    "shortLabel": "Michigan",
    "rooms": [
      {
        "name": "FireKeepers",
        "city": "Battle Creek",
        "state": "MI",
        "schedules": [
          {
            "day": "Mondays, Tuesdays, Wednesdays",
            "name": "$65 NLHE",
            "start": "12:15pm",
            "buyin": "$65"
          },
          {
            "day": "Mondays, Tuesdays, Wednesdays",
            "name": "$65 NLHE",
            "start": "6:15pm",
            "buyin": "$65"
          },
          {
            "day": "Thursdays",
            "name": "$65 NLHE",
            "start": "12:15pm",
            "buyin": "$65"
          },
          {
            "day": "Thursdays",
            "name": "$65 PLO",
            "start": "6:15pm",
            "buyin": "$65"
          },
          {
            "day": "Fridays",
            "name": "$65 NLHE",
            "start": "12:15pm",
            "buyin": "$65"
          },
          {
            "day": "Fridays",
            "name": "$125 Green Chip Bounty NLHE",
            "start": "6:15pm",
            "buyin": "$125"
          },
          {
            "day": "Fridays",
            "name": "$85 Triple Nickel Bounty",
            "start": "8:15pm",
            "buyin": "$85"
          },
          {
            "day": "Saturdays",
            "name": "$70 MSPT Milestone",
            "start": "12:15pm",
            "buyin": "$70"
          },
          {
            "day": "Saturdays",
            "name": "$275 MSPT Milestone",
            "start": "6:15pm",
            "buyin": "$275"
          },
          {
            "day": "Saturdays",
            "name": "$70 Bomb Pot PLO",
            "start": "8:15pm",
            "buyin": "$70"
          },
          {
            "day": "Sundays",
            "name": "$200 NLHE",
            "start": "12:15pm",
            "buyin": "$200"
          },
          {
            "day": "Sundays",
            "name": "$100 Mega Stack NLHE",
            "start": "4:15pm",
            "buyin": "$100"
          },
          {
            "day": "Sundays",
            "name": "$65 Pineapple",
            "start": "6:15pm",
            "buyin": "$65"
          }
        ]
      },
      {
        "name": "MGM Grand, Detroit",
        "city": "Detroit",
        "state": "MI",
        "schedules": [
          {
            "day": "Sundays",
            "name": "NLHE Sunday Tournament",
            "start": "11:30am",
            "buyin": "$300"
          }
        ]
      },
      {
        "name": "Soaring Eagle Casino & Resort",
        "city": "Mt Pleasant",
        "state": "MI",
        "schedules": [
          {
            "day": "2nd Saturday of the month",
            "name": "No-Limit Hold'em Bounty Tournament",
            "start": "12:30pm",
            "buyin": "$300"
          },
          {
            "day": "Last Saturday of the month",
            "name": "Deep Stack No-Limit Hold'em Tournament",
            "start": "12:30pm",
            "buyin": "$300"
          }
        ]
      },
      {
        "name": "Gun Lake Casino",
        "city": "Wayland",
        "state": "MI",
        "schedules": [
          {
            "day": "Saturdays",
            "name": "Green Chip Bounty",
            "start": "12:15pm",
            "buyin": "$125"
          },
          {
            "day": "Mondays, Wednesdays",
            "name": "NLH",
            "start": "7:15pm",
            "buyin": "$60"
          }
        ]
      }
    ]
  },
  "illinois-poker-rooms": {
    "title": "Illinois & Chicago Area Poker Rooms | Daily Tourneys",
    "h1": "Illinois poker rooms and casino tournaments",
    "description": "Illinois casino poker rooms in Des Plaines, Elgin, and Rockford, with daily and weekly tournament schedules on file.",
    "intro": "Casino poker rooms in the Chicago suburbs of Des Plaines and Elgin, plus Rockford. Open a room for contact details. Daily and weekly events are listed under a room only when a schedule is on file.",
    "footerLabel": "Illinois poker rooms",
    "shortLabel": "Illinois",
    "rooms": [
      {
        "name": "Rivers Casino, Des Plaines",
        "city": "Des Plaines",
        "state": "IL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "No-Limit Texas Hold'em Tournament",
            "start": "11am",
            "buyin": "$250"
          }
        ]
      },
      {
        "name": "Grand Victoria Casino",
        "city": "Elgin",
        "state": "IL",
        "schedules": [
          {
            "day": "Sundays",
            "name": "Deep Stack NLH",
            "start": "12:00pm",
            "buyin": "$300"
          },
          {
            "day": "Tuesdays",
            "name": "NLH",
            "start": "5:00pm",
            "buyin": "$150"
          },
          {
            "day": "Fridays",
            "name": "NLH",
            "start": "6:00pm",
            "buyin": "$250"
          }
        ]
      },
      {
        "name": "Hard Rock Casino Rockford",
        "city": "Rockford",
        "state": "IL",
        "schedules": [
          {
            "day": "Mondays",
            "name": "Money Monday NLHE $3,000 GTD",
            "start": "6:00pm",
            "buyin": "$200"
          },
          {
            "day": "Wednesdays",
            "name": "Wild Wednesday NLHE $1,500 GTD",
            "start": "6:00pm",
            "buyin": "$100"
          },
          {
            "day": "Thursdays",
            "name": "Thursday Bounty NLHE",
            "start": "6:00pm",
            "buyin": "$125"
          }
        ]
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./js/metro-hubs.js